import { render, staticRenderFns } from "./myprofile.vue?vue&type=template&id=6a7fd616&scoped=true"
import script from "./myprofile.vue?vue&type=script&lang=js"
export * from "./myprofile.vue?vue&type=script&lang=js"
import style0 from "./myprofile.vue?vue&type=style&index=0&id=6a7fd616&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7fd616",
  null
  
)

export default component.exports